"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _DataDisplayWidget = _interopRequireDefault(require("./Style/DataDisplayWidget"));

var _utils = _interopRequireDefault(require("../../../../utils"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var _errorPage = _interopRequireDefault(require("./../../../error-views/errorPage"));

var _TableData = _interopRequireDefault(require("./TableData"));

var _reactCsv = require("react-csv");

var _CardData = _interopRequireDefault(require("./CardData"));

var _RmName = _interopRequireDefault(require("../../../../RmName.json"));

var innerwidth = window.innerWidth;
var header = [{
  label: _RmName.default.nameCode,
  key: "RM_code"
}, {
  label: "CLcode",
  key: "CL_code"
}, {
  label: "Date",
  key: "Today_Date"
}, {
  label: "End Date",
  key: "Date"
}, {
  label: "Attendance",
  key: "Attendance"
}];

var RMAttendance = function RMAttendance() {
  var date = new Date();
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  var today = "".concat(year, "-").concat(month, "-").concat(day);
  var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      searchData = _useState8[0],
      setSearchData = _useState8[1];

  (0, _react.useEffect)(function () {
    function getData() {
      return _getData.apply(this, arguments);
    }

    function _getData() {
      _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var url;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _config.default.getRMAttendanceDetails + cl;
                _context.next = 3;
                return _axios.default.get(url, {
                  headers: {
                    'Authorization': token
                  }
                }).then(function (response) {
                  if (response.data.status === "error") setapiError(response.data);else {
                    response.data.forEach(function (obj) {
                      obj.Today_Date = dateFormate(obj.Today_Date);
                      obj.Date = dateFormate(obj.Date);
                    });
                    var rmDetails = response.data;
                    setData(rmDetails); //setAllData(rmDetails);

                    setSearchData(rmDetails);
                    setLoading(false);
                  }
                }, function (error) {
                  var obj = {
                    "status": "error",
                    "message": "Network Error"
                  };
                  if (error.response) setapiError(error.response);else setapiError(obj);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getData.apply(this, arguments);
    }

    getData();
  }, [cl, token]);
  var csvRport = {
    filename: "RM Attendance ".concat(today, " ").concat(time),
    headers: header,
    data: data
  };

  function dateFormate(changeDate) {
    var date = new Date(changeDate);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    var todayDate = "".concat(year, "-").concat(month, "-").concat(day);
    return todayDate;
  }

  var onSearch = function onSearch(e) {
    var value = e.currentTarget.value;

    var searchdata = _utils.default.wildCardSearch(searchData, value);

    setData(searchdata);
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 20,
    xl: 20,
    xxl: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Filter"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [8, 8]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 9,
    xl: 9,
    xxl: 9
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    }
  }))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 4,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    title: "Total ".concat(_RmName.default.name),
    color: "cyan",
    size: "20",
    vertical: true,
    avatarSize: 30,
    style: {
      height: 132
    }
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "".concat(_RmName.default.name, " Attendance"),
    style: {
      'fontSize': '5px'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_TableData.default, {
    data: data
  }) : /*#__PURE__*/_react.default.createElement(_CardData.default, {
    data: data
  })));
};

var _default = RMAttendance;
exports.default = _default;